import React, { createContext, useContext, useReducer } from 'react'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { DATA_SOURCE_DATA } from '../../components/Filters/DataSourceSelector/data/groups'

interface Props {
  children: React.ReactNode
}

interface IValue {
  formattedState: CustomState
  dispatch: React.Dispatch<CustomFiltersAction>
}

export const EMPLOYEE_COSTS_ACTION = 'SET_EMPLOYEE_COSTS'

export interface CustomState {
  employeeCosts?: DATA_SOURCE_DATA
}

export type CustomFiltersAction = { type: typeof EMPLOYEE_COSTS_ACTION; payload?: DATA_SOURCE_DATA }

export const initialState: CustomState = {
  employeeCosts: {
    agreement_data: [],
    employee_expenses: [],
    labor_costs: [],
  },
}

const reducer = (state: CustomState, action: CustomFiltersAction): CustomState => {
  switch (action.type) {
    case EMPLOYEE_COSTS_ACTION:
      return { ...state, employeeCosts: action.payload }
    default:
      return state
  }
}

const CustomFiltersProviderContext = createContext<IValue | undefined>(undefined)

export const CustomFiltersProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const formattedState = useUnsafeMemo(
    () => ({
      employeeCosts: state.employeeCosts,
    }),
    [state]
  )

  return (
    <CustomFiltersProviderContext.Provider value={{ formattedState, dispatch }}>
      {children}
    </CustomFiltersProviderContext.Provider>
  )
}

export const useCustomFilters = () => {
  const context = useContext(CustomFiltersProviderContext)
  if (context === undefined) {
    throw new Error('useCustomFilters must be used within a CustomFiltersProvider')
  }
  return context
}
